<template>
  <ion-app>
    <SidebarMenu v-if="userAuth().can('view sidebar')"></SidebarMenu>
    <ion-router-outlet id="main-content" />
  </ion-app>
</template>

<script lang="ts">
import { IonApp, IonRouterOutlet } from '@ionic/vue';
import { defineComponent } from 'vue';
import SidebarMenu from '@/components/SidebarMenu.vue';
import userAuth from '@/composables/userAuth';

export default defineComponent({
  name: 'App',
  components: {
    IonApp,
    IonRouterOutlet,
    SidebarMenu
  },
  setup() {
    return { userAuth };
  }
});
</script>